import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, Menu, MenuItem, Tooltip } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useState } from 'react';

import { SCREEN_XS_PX } from 'LEGACY/constants';

const DownloadDropdown = ({
  buttons,
  label,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const screenXS = useMediaQuery(`(max-width:${SCREEN_XS_PX})`);

  const handleDropDownClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return buttons.length > 0 && (
    <>
      {buttons.length === 1 ? (() => {
        const { label, href, blank, download, pdf_download_enabled = true, pdf_disabled_tooltip } = buttons[0];
        return (
          <Tooltip
            title={pdf_download_enabled ? '' : pdf_disabled_tooltip}
          >
            {/* span added to avoid the disabled pointer events on MUI disabled buttons */}
            <span>
              <Button
                component='a'
                variant='contained'
                color='inherit'
                href={pdf_download_enabled ? href : null}
                target={blank ? '_blank' : '_self'}
                rel={blank ? 'noopener noreferrer' : null}
                download={download}
                disabled={!pdf_download_enabled}
              >
                <CloudDownloadIcon sx={{ mr: !screenXS && 1 }} />
                {!screenXS && label}
              </Button>
            </span>
          </Tooltip>
        );
      })() : (
        <>
          <Button
            variant='contained'
            color='inherit'
            onClick={handleDropDownClick}
          >
            <CloudDownloadIcon sx={{ mr: !screenXS && 0.8 }} />
            {!screenXS && label}
            <DownIcon />
          </Button>
          <Menu
            open={Boolean(menuAnchorEl)}
            anchorEl={menuAnchorEl}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            disableAutoFocusItem
          >
            {
              buttons.map(({ label, href, blank, download, pdf_download_enabled = true, pdf_disabled_tooltip }) => (
                href &&
                  <Tooltip
                    key={label}
                    title={pdf_download_enabled ? '' : pdf_disabled_tooltip}
                    placement='right'
                  >
                    <span>
                      <MenuItem
                        component='a'
                        onClick={handleMenuClose}
                        href={pdf_download_enabled ? href : null}
                        target={blank ? '_blank' : '_self'}
                        rel={blank ? 'noopener noreferrer' : null}
                        download={download}
                        disabled={!pdf_download_enabled}
                      >
                        {label}
                      </MenuItem>
                    </span>
                  </Tooltip>
              ))
            }
          </Menu>
        </>
      )}
    </>
  );
};

export default DownloadDropdown;
